import React, { useEffect } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { GET_MK_CATEGORY_DATA_URL } from '../utils/Constants';
import mainSearchStore from '../store/main-search';

function MkCategoryRedirect() {
  let { category} = useParams();
  let history = useHistory();
  const {mainInfo, clearMainInfo, setMkInfo} = mainSearchStore();
    useEffect(() => {
        // Redirect to the category page
        //window.location.href = `/category/${category}`;
        clearMainInfo();
        console.log(`Redirecting to category: ${category}`);
        searchCategoryInfo(category);
    }, []);

    useEffect(() => {
        // Set the main search info
        console.log(`Setting main search info for category: ${category}`);
        
    }
    , [mainInfo?.mkInfo]);

async function searchCategoryInfo(category) {
    const responseData = await fetch(GET_MK_CATEGORY_DATA_URL + category, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
    const data = await responseData.json();
    console.log("Category data received:", data);
    setMkInfo("", data.keyword, data.title, data.description);
    setTimeout(function(){
        history.push(`/search-result-ng/${data.keyword === ""? "$EMPTY$" : data.keyword }/${mainInfo.selectIndex === "" ? "All" : mainInfo.selectIndex}?query=${data.keyword === ""? "$EMPTY$" : data.keyword}`);
    },500);
}
  return (
    <div>
    </div>
  );
}
export default MkCategoryRedirect;